var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.5 5h-18c-.19891 0-.38968.07902-.53033.21967s-.21967.33142-.21967.53033v12.75c0 .3978.15804.7794.43934 1.0607s.66284.4393 1.06066.4393h16.5c.3978 0 .7794-.158 1.0607-.4393s.4393-.6629.4393-1.0607v-12.75c0-.19891-.079-.38968-.2197-.53033-.1406-.14065-.3314-.21967-.5303-.21967zm-1.9284 1.5-7.0716 6.4828-7.07156-6.4828zm1.1784 12h-16.5v-11.04469l7.7428 7.09779c.1384.127.3194.1975.5072.1975s.3688-.0705.5072-.1975l7.7428-7.09779z","fill":"#8d8d8d"}));
}

MailIcon.defaultProps = {"fill":"none","height":"25","viewBox":"0 0 25 25","width":"25"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
